var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBoxRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.95 2.271a2.02 2.02 0 0 0-1.91 0L4.4 5.311c-.41.23-.67.67-.67 1.15 0 .49.25.93.67 1.15l5.65 3.04a2 2 0 0 0 1.9 0l5.65-3.04c.41-.22.67-.66.67-1.15 0-.48-.26-.92-.67-1.15l-5.65-3.04zM3.87 9.09A1.286 1.286 0 0 0 2 10.24v4.96c0 .86.48 1.63 1.25 2.02l5.25 2.62c.18.09.38.14.58.14.23 0 .47-.07.68-.19.38-.24.61-.65.61-1.1v-4.96c-.01-.86-.49-1.63-1.25-2.02L3.87 9.09zM20 12.7c-.48-.14-.99-.2-1.5-.2-1.36 0-2.69.47-3.74 1.31-1.44 1.13-2.26 2.84-2.26 4.69 0 .49.06.98.19 1.45-.15-.02-.3-.08-.44-.17-.38-.23-.61-.64-.61-1.09v-4.96c0-.86.48-1.63 1.24-2.02l5.25-2.62A1.286 1.286 0 0 1 20 10.24v2.46z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.441 14c-1.13.01-2.26.46-3.12 1.32-.6.59-.99 1.33-1.18 2.1-.11.42-.15.85-.12 1.28v.05c0 .07.01.13.02.21l.01.01V19c.09.98.51 1.93 1.27 2.68a4.473 4.473 0 0 0 4.26 1.18c.44-.11.87-.29 1.27-.53.3-.17.58-.39.83-.65.75-.75 1.18-1.7 1.27-2.69.01 0 .01-.02.01-.03a.82.82 0 0 0 .02-.22c0-.01.01-.03.01-.05.06-1.21-.38-2.45-1.31-3.37a4.479 4.479 0 0 0-3.24-1.32zm.73 6.21-.66-.66-.68.68c-.3.3-.77.3-1.06 0-.3-.29-.3-.76 0-1.06l.68-.68-.66-.66a.754.754 0 0 1 0-1.06c.3-.3.77-.3 1.07 0l.65.66.63-.64c.3-.29.77-.29 1.07 0 .29.3.29.77 0 1.07l-.64.63.66.65c.3.3.3.77 0 1.07-.29.29-.76.29-1.06 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBoxRemove);
export default __webpack_public_path__ + "static/media/vuesax-bold-box-remove.9545e55ff876d5b611b546bf51906e22.svg";
export { ForwardRef as ReactComponent };